// extracted by mini-css-extract-plugin
export var opened = "SidebarTrigger-module--opened--JmLPY";
export var root = "SidebarTrigger-module--root--VBUQT";